import { render, staticRenderFns } from "./email-verification-banner.vue?vue&type=template&id=076f8a9e&scoped=true"
import script from "./email-verification-banner.vue?vue&type=script&lang=js"
export * from "./email-verification-banner.vue?vue&type=script&lang=js"
import style0 from "./email-verification-banner.vue?vue&type=style&index=0&id=076f8a9e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076f8a9e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('076f8a9e')) {
      api.createRecord('076f8a9e', component.options)
    } else {
      api.reload('076f8a9e', component.options)
    }
    module.hot.accept("./email-verification-banner.vue?vue&type=template&id=076f8a9e&scoped=true", function () {
      api.rerender('076f8a9e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/client-portal/js/modules/banners/email-verification-banner.vue"
export default component.exports